import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { GeneralType } from "../../../../lib/types";
import {
  ARMY_UNITS,
  BATTLE_TACTICS,
  GENERAL_TYPE,
  systemClass
} from "../../../../lib/enums";
import ArmyUnitPerson from "./ArmyUnitPerson";

import { armyUnits } from "../../../../assets/images/army";
import ArmyFormationPersons from "./ArmyFormationPersons";
import { setSameHeight } from "../../../../lib/elementUtilities";
import SubMenu from "../../../Menu/SubMenu";
import { recruitUnit, releaseUnit, setBattleTactics } from "../../../../store/actions";
import HelpIcon from "../../../Common/HelpIcon";
import { isTacticsAvailable } from "../../../../lib/commonFunctions";

const mapStateToProps = (state: any) => ({
  race: state.governorate.race,
  readyToAttack: state.governorate.readyToAttack,
  armyCapacityUsage: state.governorate.armyCapacityUsage,
  army: state.governorate.army,
  battleTactics: state.governorate.battleTactics,
  armyFormation: state.governorate.armyFormation,
  soldierGeneral: state.governorate.generals
    .find((g: GeneralType) => g.typeId === GENERAL_TYPE.SOLDIER).general
})

const connector = connect(mapStateToProps);

const Army = ({
  race,
  readyToAttack,
  armyCapacityUsage,
  army,
  battleTactics,
  armyFormation,
  soldierGeneral
}: ConnectedProps<typeof connector>) => {
  const armyPersonsRef = useRef<HTMLDivElement>(null);
  // @ts-ignore
  const [tactics, setTactics] = useState(Object.values(armyFormation)
    .find(b => !!b)?.tactics.id || 1);

  const handleTacticsChange = (tacticsId: number) => {
    if (!isTacticsAvailable(battleTactics[tacticsId], armyFormation)) {
      return;
    }

    setTactics(tacticsId);
    if (Object.values(armyFormation).filter(Boolean).length > 0) {
      dispatch(setBattleTactics(tacticsId));
    }
  }

  useEffect(() => {
    setSameHeight(armyPersonsRef.current || undefined);
  }, []);
  const dispatch = useDispatch();

  return (
    <>
      <SubMenu
        tabs={[
          {
            name: "Army",
            title: "Army",
            icon: "armada",
            label: "Army",
            active: true,
            parameters: {
              reload: false
            }
          },
          {
            name: "ArmyEmperorTent",
            title: "Army",
            icon: "armada",
            label: "Emperor Tent",
            active: false,
            parameters: {
              reload: true
            }
          }
        ]}
      />
    <section className="boxes-group">
      <div className="box text-info">
        <p>
          Army capacity used {armyCapacityUsage.armyUnits}/{
          armyCapacityUsage.armyUnitsLimit}
          {
            !readyToAttack
              ? <><br/><span className="negative">You can not form your army into banner until 8th turn or out of war.
                {soldierGeneral ? "" : "You need soldier general to form a banner."}
          </span></> : <></>
          }
        </p>
      </div>
      <span className="divider"/>

      <h2 className="h2 h2-first">
        <span className="bordered">Units</span>
      </h2>
      <span className="divider"/>
      <div className="box">
        <div ref={armyPersonsRef} className="row persons army">
          <div className="col-sm-6 col-md-25 person-col">
            <ArmyUnitPerson
              unitType={"E1"}
              unit={army[ARMY_UNITS.E1]}
              picture={`${race.id}1`}
              recruit={amount => dispatch(recruitUnit(ARMY_UNITS.E1, amount))}
              release={amount => dispatch(releaseUnit(ARMY_UNITS.E1, amount))}
            />
          </div>
          <div className="col-sm-6 col-md-25 person-col">
            <ArmyUnitPerson
              unitType={"E2"}
              unit={army[ARMY_UNITS.E2]}
              picture={`${race.id}2`}
              recruit={amount => dispatch(recruitUnit(ARMY_UNITS.E2, amount))}
              release={amount => dispatch(releaseUnit(ARMY_UNITS.E2, amount))}
            />
          </div>
          <div className="col-sm-6 col-md-25 person-col">
            <ArmyUnitPerson
              unitType={"E3"}
              unit={army[ARMY_UNITS.E3]}
              picture={`${race.id}3`}
              recruit={amount => dispatch(recruitUnit(ARMY_UNITS.E3, amount))}
              release={amount => dispatch(releaseUnit(ARMY_UNITS.E3, amount))}
            />
          </div>
          <div className="col-sm-6 col-md-25 person-col">
            <ArmyUnitPerson
              unitType={"s_engines"}
              unit={army[ARMY_UNITS.SIEGE_ENGINE]}
              picture={"S"}
              soldierGeneral={soldierGeneral}
              recruit={amount => dispatch(recruitUnit(ARMY_UNITS.SIEGE_ENGINE, amount))}
              release={amount => dispatch(releaseUnit(ARMY_UNITS.SIEGE_ENGINE, amount))}
            />
          </div>
          <div className="col-sm-6 col-md-25 person-col">
            <div className={`person ${systemClass.MatchHeight}`}>
              <h3 className="name">Red dragon</h3>
              <img src={armyUnits.armyD} alt=""/>
              <p className="white">
                <div className="icons">
                  <p>Magic creature of unknown powers</p>
                </div>
                <p className="white">
                  <div className="row">
                    <div
                      className="col-md-4 text-center js-units-dragon col-md-offset-4">{army[ARMY_UNITS.DRAGON]}</div>
                  </div>
                  <div>&nbsp;</div>
                </p>
              </p>
            </div>
          </div>
        </div>

      </div>
      <span className="divider"/>

      <h2 className="h2 h2-first">
        <span className="bordered">Banners</span>
      </h2>
      <span className="divider"/>
      <div className="box">
        {readyToAttack
          ? <>
            <div className={"text-info"}>
              <p style={{ margin: "auto", paddingTop: "10px", paddingBottom: "20px" }}>
                <i className="icon icon-armada middle"/> Battle tactics <i className="icon icon-armada middle"/>
              </p>
            </div>
              <div className={"row"} style={{ paddingBottom: "15px" }}>
                <div className={`col-md-3 ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.PHALANX], armyFormation)
                  ? " text-disabled" : " grey"}`}>
                  <div
                    className={`radio-wrap${tactics === BATTLE_TACTICS.PHALANX ? " checked" : ""}
              ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.PHALANX], armyFormation) ? " disabled" : ""}`}
                    onClick={() => handleTacticsChange(BATTLE_TACTICS.PHALANX)}
                  >
                    <input
                      type={"radio"}
                      checked={tactics === BATTLE_TACTICS.PHALANX}
                      disabled={false}
                    />
                  </div>
                  {tactics === BATTLE_TACTICS.PHALANX ? <em>Phalanx</em> : "Phalanx"}
                  <HelpIcon
                    title={battleTactics[BATTLE_TACTICS.PHALANX].name}
                    content={`<div>
${battleTactics[BATTLE_TACTICS.PHALANX].bonus1}<br />
${battleTactics[BATTLE_TACTICS.PHALANX].bonus2}<br />
${battleTactics[BATTLE_TACTICS.PHALANX].malus}<br />
${battleTactics[BATTLE_TACTICS.PHALANX].objective}<br />
Max units LF: ${battleTactics[BATTLE_TACTICS.PHALANX].left} Center: ${battleTactics[BATTLE_TACTICS.PHALANX].center} RF: ${battleTactics[BATTLE_TACTICS.PHALANX].right} B ${battleTactics[BATTLE_TACTICS.PHALANX].backup}
</div>`}
                    iconClasses={["white"]}
                  />
                </div>
                <div className={`col-md-3 ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER], armyFormation)
                  ? " text-disabled" : " grey"}`}>
                  <div
                    className={`radio-wrap${tactics === BATTLE_TACTICS.OBLIQUE_ORDER ? " checked" : ""}
              ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER], armyFormation) ? " disabled" : ""}`}
                    onClick={() => handleTacticsChange(BATTLE_TACTICS.OBLIQUE_ORDER)}
                  >
                    <input
                      type={"radio"}
                      checked={tactics === BATTLE_TACTICS.OBLIQUE_ORDER}
                      disabled={false}
                    />
                  </div>
                  {tactics === BATTLE_TACTICS.OBLIQUE_ORDER ? <em>Oblique order</em> : "Oblique order"}&nbsp;
                  <HelpIcon
                    title={battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].name}
                    content={`<div>
${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].bonus1}<br />
${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].bonus2}<br />
${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].malus}<br />
${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].objective}<br />
Max units LF: ${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].left} Center: ${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].center} RF: ${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].right} B ${battleTactics[BATTLE_TACTICS.OBLIQUE_ORDER].backup}
</div>`}
                    iconClasses={["white"]}
                  />
                </div>
                <div className={`col-md-3 ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.TULUGHAMA], armyFormation)
                  ? " text-disabled" : " grey"}`}>
                  <div
                    className={`radio-wrap${tactics === BATTLE_TACTICS.TULUGHAMA ? " checked" : ""}
              ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.TULUGHAMA], armyFormation) ? " disabled" : ""}`}
                    onClick={() => handleTacticsChange(BATTLE_TACTICS.TULUGHAMA)}
                  >
                    <input
                      type={"radio"}
                      checked={tactics === BATTLE_TACTICS.TULUGHAMA}
                      disabled={false}
                    />
                  </div>
                  {tactics === BATTLE_TACTICS.TULUGHAMA ? <em>Tulughama</em> : "Tulughama"}&nbsp;
                  <HelpIcon
                    title={battleTactics[BATTLE_TACTICS.TULUGHAMA].name}
                    content={`<div>
${battleTactics[BATTLE_TACTICS.TULUGHAMA].bonus1}<br />
${battleTactics[BATTLE_TACTICS.TULUGHAMA].bonus2}<br />
${battleTactics[BATTLE_TACTICS.TULUGHAMA].malus}<br />
${battleTactics[BATTLE_TACTICS.TULUGHAMA].objective}<br />
Max units LF: ${battleTactics[BATTLE_TACTICS.TULUGHAMA].left} Center: ${battleTactics[BATTLE_TACTICS.TULUGHAMA].center} RF: ${battleTactics[BATTLE_TACTICS.TULUGHAMA].right} B ${battleTactics[BATTLE_TACTICS.TULUGHAMA].backup}
</div>`}
                    iconClasses={["white"]}
                  />
                </div>
                <div className={`col-md-3 ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.CHARGE], armyFormation)
                  ? " text-disabled" : " grey"}`}>
                  <div
                    className={`radio-wrap${tactics === BATTLE_TACTICS.CHARGE ? " checked" : ""}
              ${!isTacticsAvailable(battleTactics[BATTLE_TACTICS.CHARGE], armyFormation) ? " disabled" : ""}`}
                    onClick={() => handleTacticsChange(BATTLE_TACTICS.CHARGE)}
                  >
                    <input
                      type={"radio"}
                      checked={tactics === BATTLE_TACTICS.CHARGE}
                      disabled={false}
                    />
                  </div>
                  {tactics === BATTLE_TACTICS.CHARGE ? <em>Charge</em> : "Charge"}&nbsp;
                  <HelpIcon
                    title={battleTactics[BATTLE_TACTICS.CHARGE].name}
                    content={`<div>
${battleTactics[BATTLE_TACTICS.CHARGE].bonus1}<br />
${battleTactics[BATTLE_TACTICS.CHARGE].bonus2}<br />
${battleTactics[BATTLE_TACTICS.CHARGE].malus}<br />
${battleTactics[BATTLE_TACTICS.CHARGE].objective}<br />
Max units LF: ${battleTactics[BATTLE_TACTICS.CHARGE].left} Center: ${battleTactics[BATTLE_TACTICS.CHARGE].center} RF: ${battleTactics[BATTLE_TACTICS.CHARGE].right} B ${battleTactics[BATTLE_TACTICS.CHARGE].backup}
</div>`}
                    iconClasses={["white"]}
                  />
                </div>
              </div>
            <ArmyFormationPersons
              formation={armyFormation}
              tactics={tactics}
            />
          </>
          : soldierGeneral
            ? <span className="negative">Army can not be sent to battle until 8th turn and out of war</span>
            : <span className="negative">You need soldier general to lead army to battle</span>
        }
        <span className={"divider"} />
      </div>

    </section>
    </>
  )
}

export default connector(Army);
